import React from "react";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { Image } from "common/components";
import { convertSecondsToHMS } from "common/utils";
import { isEmpty } from "lodash";
import { mergeCss } from "mrb/common/utils";
import { useRootStore } from "mrb/core";

function LoadioAlbumTrackTemplate({ item, wrapperClassName, isActive, t, downloadAlbumTrack }) {
    const rootStore = useRootStore();
    const artworkUrl = item.artworkFileEntryId
        ? rootStore.coverImageFactory.createLoadioAlbumTrackCoverImageUrl(item.artworkFileEntryId, 50, 50)
        : null;

    return (
        <div className={mergeCss("c-card c-card--primary", wrapperClassName)}>
            <div className="u-display--flex u-display--flex--ai--center u-gap--base">
                <Image
                    className="c-home__preview__icon"
                    src={isEmpty(item.artworkUrl) ? artworkUrl : item.artworkUrl}
                    width="50"
                    height="50"
                />
                <div className="u-width--100">
                    <div className="c-home__preview__title u-mar--bottom--small u-width--100">
                        <div className="u-display--flex u-display--flex--ai--center u-display--flex--jc--space-between u-width--100 u-gap--med">
                            <div className="u-display--flex u-display--flex--ai--center u-gap--sml">
                                <p className="u-type--ellipsis">{item.title}</p>
                            </div>
                            {/* 
                            <div className="u-display--flex u-display--flex--ai--center u-gap--sml">
                                {item.audioStreamUrl && (
                                    <button
                                        onClick={() => downloadAlbumTrack(item)}
                                        className="c-btn c-btn--primary c-btn--rounded c-btn--rounded--sml c-btn--icon"
                                    >
                                        <i className="u-icon u-icon--base u-icon--expand--down"></i>
                                    </button>
                                )}
                            </div> */}
                        </div>
                    </div>
                    <p className="u-type--sml u-type--color--opaque">{convertSecondsToHMS(item.duration)}</p>
                </div>
            </div>

            <div className="u-mar--top--sml">
                <p className="u-type--sml u-type--color--opaque">Stream URL</p>
                <a
                    href={item.audioStreamUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="u-display--ib u-type--base u-type--ellipsis"
                >
                    {item.audioStreamUrl}
                </a>
            </div>

            <div className="row u-mar--top--tny">
                <React.Fragment>
                    {item.audioFileBitrate > 0 && item.audioFileSize > 0 && (
                        <>
                            <div className="col col-sml-3">
                                <p className="u-type--sml u-type--color--opaque">MP3 file bitrate</p>
                                <p className="u-type--break u-type--sml"> {`${item.audioFileBitrate / 1000} Kbit/s`}</p>
                            </div>
                            <div className="col col-sml-3">
                                <p className="u-type--sml u-type--color--opaque">MP3 file size</p>
                                <p className="u-type--break u-type--sml">
                                    {`${(item.audioFileSize / Math.round(1024 * 1024)).toFixed(2)} MB`}
                                </p>
                            </div>
                        </>
                    )}
                    {item.genre && (
                        <div className="col col-sml-6">
                            <p className="u-type--sml u-type--color--opaque">Genre</p>
                            <p className="u-type--break u-type--sml"> {item.genre?.name}</p>
                        </div>
                    )}
                </React.Fragment>
            </div>
        </div>
    );
}

LoadioAlbumTrackTemplate.propTypes = {
    item: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default observer(LoadioAlbumTrackTemplate);
